<template>
  <div class="c-library-select">
    <button
      type="button"
      class="c-library-select__selected"
      @click.prevent="showDropdown()"
    >
      <div class="c-library-select__text" id="librarySorter">{{ $t(selected.text) }}</div>
      <div class="c-library-select__icon">
        <arrow class="c-library-select__icon-arrow"></arrow>
      </div>
    </button>

    <div v-if="show" class="c-library-select__dropdown">
      <button
        type="button"
        v-for="(option, i) in options"
        :key="i"
        class="c-library-select__item"
        :tabindex="canTab"
        :class="{'c-library-select__item--check': selectedIndex === i}"
        @click.prevent="chooseOption(option, i)"
        :aria-selected="selectedIndex === i ? 'true' : 'false'"
      >
        {{ $t(option.text) }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Arrow from '@/assets/svg/Arrow'

export default {
  name: 'LibrarySelect',

  components: {
    'arrow': Arrow
  },

  data() {
    return {
      selected: {
        value: 'by_latest',
        text: 'RECENTLY_OPENED'
      },
      options: [
        {
          value: 'by_latest',
          text: 'RECENTLY_OPENED'
        },
        {
          value: 'by_newest',
          text: 'NEWEST'
        },
        {
          value: 'by_title_asc',
          text: 'ORDER_ASC'
        },
        {
          value: 'by_title_desc',
          text: 'ORDER_DESC'
        },
        {
          value: 'by_size_asc',
          text: 'SIZE_ASC'
        },
        {
          value: 'by_size_desc',
          text: 'SIZE_DESC'
        }
      ],
      selectedIndex: 0,
      show: false
    }
  },

  computed: {
    canTab() {
      return this.show ? 0 : -1
    },

    ...mapState('userSettings', {
      libraryFilter: state => state.libraryFilter
    })
  },

  mounted() {
    document.addEventListener('click', e => {
      const isSVGElement = () => {
        if (
          e.target.farthestViewportElement &&
          e.target.farthestViewportElement.classList.contains('c-library-select__icon-arrow')
        ) {
          return true
        }

        return false
      }

      if(
        !isSVGElement() &&
        !e.target.classList.contains('c-libary-select') &&
        !e.target.classList.contains('c-library-select__text') &&
        !e.target.classList.contains('c-library-select__icon-arrow') &&
        !e.target.classList.contains('c-library-select__selected')
      ) {
        this.show = false
      }
    })

    this.selected = this.libraryFilter
    this.selectedIndex = this.options.findIndex(o => o.value === this.selected.value)

    window.addEventListener('scroll', () => {
      this.show = false
    })
  },

  watch: {
    'selected.value' () {
      this.selectedSetter()
    }
  },

  beforeDestroy () {
    window.removeEventListener('scroll', () => {
      this.show = false
    })
  },

  methods: {
    showDropdown() {
      this.show = !this.show
    },

    chooseOption(option, i) {
      this.selected = option
      this.selectedIndex = i
      this.show = false
    },

    selectedSetter() {
      this.setLibraryFilter(this.selected)
    },

    ...mapActions({
      setLibraryFilter: 'userSettings/setLibraryFilter',
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-library-select {
  display: inline-block;
  min-width: 100px;
  margin-left: 0.25em;
  position: relative;
}

.c-library-select__selected {
  @include btnReset();
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;
  @include a11yOutline();
}

.c-library-select__text {
  color: $blue;
  font-weight: 700;
}

.c-library-select__dropdown {
  position: absolute;
  top: 2.5em;
  right: 0;
  width: auto;
  background: $dark-blue;
  padding: .75em 0;
  z-index: 999;
  border-radius: 0.7em;

  color: $white;
}

.c-library-select__item {
  @include btnReset();
  position: relative;
  text-align: left;
  width: 100%;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 700;
  font-size: 0.9em;
  padding: .45em 2em .45em 1em;

  &:hover {
    background-color: $lighter-dark-blue;
  }
  @include a11yOutline();

  &--check:after {
    content: '';
    position: absolute;
    right: 14px;
    top: 6px;
    width: 8px;
    height: 12px;
    border: solid $white;
    border-width:0 3px 3px 0;
    transform: rotate(45deg);
  }
}
</style>

